import { render, staticRenderFns } from "./ChecklistItemPopup.vue?vue&type=template&id=b445d06e&"
import script from "./ChecklistItemPopup.vue?vue&type=script&lang=js&"
export * from "./ChecklistItemPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports